document.addEventListener('DOMContentLoaded', function() {
  const filtersContainer = document.getElementById('filters-container');
  const clearFilterBtn = document.getElementById('clear-filters');

  if(filtersContainer) {
    filtersContainer.addEventListener('click', function(event) {
      if (event.target.classList.contains('remove-filter-button')) {
        event.target.closest('.filter-row').remove();
      }
    });
  }

  if(clearFilterBtn) {
    clearFilterBtn.addEventListener('click', function(event) {
      event.preventDefault();
      location.reload()
    })
  }

  window.applyFilters = function(event, eventUrl) {
    event.preventDefault();
    const formData = new FormData(document.getElementById('filter-form'));
    if(eventUrl === '/welcome/team_requests') {
      formData.append('request_status', filterStatusValue);
      formData.append('request_type', filterTypeValue);
      formData.append('department_id', departmentIdValue);
      formData.append('search', searchValue);
    }
    const locale = document.documentElement.lang;
    formData.append('locale', locale);
    $.ajax({
      url: eventUrl,
      method: 'POST',
      headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: formData,
      processData: false, // Prevent jQuery from automatically processing the data
      contentType: false, // Prevent jQuery from setting the content type
      dataType: 'script',
      success: function(data) {
        var closeButton = document.querySelector('[data-bs-dismiss="offcanvas"]');
        if (closeButton) {
          closeButton.click();
        }
      },
      error: function(error) {
        var filterError = document.getElementById('filter-error');
        if(filterError) {
            filterError.textContent = "Error applying filters. Please try again.";
          filterError.classList.remove('d-none');
          setTimeout(function() {
            filterError.classList.add('d-none');
            filterError.textContent = '';
          }, 5000);
        }
      }
    });
  };

  window.updateOperator = function(attributeSelect, model) {
    var selectedAttribute = attributeSelect.value;
    // Parse enums attached to the select via data-enums (set in the partial)
    var enums = {};
    try {
      enums = attributeSelect.dataset && attributeSelect.dataset.enums ? JSON.parse(attributeSelect.dataset.enums) : {};
    } catch (e) {
      enums = {};
    }

    if(selectedAttribute) {
      $.ajax({
        url: `/employees/get_column_type?model=${model}`,
        method: 'GET',
        data: { attribute: selectedAttribute },
        success: function(data) {
          var dataType = data[selectedAttribute];
          var row = attributeSelect.closest('.filter-row');
          var operatorSelect = row.querySelector('.filter-op');
          var valueField = row.querySelector('.value-field');
          var valueNumber = row.querySelector('.value-number');
          var valueDate = row.querySelector('.value-date');
          var valueDateTime = row.querySelector('.value-date-time');
          var valueSelect = row.querySelector('.value-select');
          var valueEnum = row.querySelector('.value-enum');

          var defaultOperators = [{ value: '=', text: 'Equals' }, { value: '!=', text: 'Not Equals' }];
          if (dataType === 'date' || dataType === 'datetime' || dataType === 'integer' || dataType === 'decimal' || dataType === 'float') {
            defaultOperators.push({ value: '>', text: 'Greater Than' })
            defaultOperators.push({ value: '<', text: 'Less Than' })
            defaultOperators.push({ value: '>=', text: 'Greater Than Or Equals' })
            defaultOperators.push({ value: '<=', text: 'Less Than Or Equals' })
          } else if (dataType === 'string' || dataType === 'text') {
            defaultOperators.push({ value: 'like', text: 'Like' })
          }

          // Destroy previous TomSelect instances if present
          if (valueSelect && valueSelect.tomselect) {
            try { valueSelect.tomselect.destroy(); } catch(e){}
          }
          if (valueEnum && valueEnum.tomselect) {
            try { valueEnum.tomselect.destroy(); } catch(e){}
          }
          if (operatorSelect && operatorSelect.tomselect) {
            // we'll update operator options below
          }

          // Hide & disable all value inputs initially
          [valueField, valueNumber, valueDate, valueDateTime, valueSelect, valueEnum].forEach(function(el){
            if(!el) return;
            el.classList.add('d-none');
            el.disabled = true;
            if (el.tagName === 'SELECT') el.selectedIndex = 0;
            else el.value = '';
          });

          // If this attribute is an enum according to the dataset, show enum select
          if (enums && Object.prototype.hasOwnProperty.call(enums, selectedAttribute) && valueEnum) {
            var enumMap = enums[selectedAttribute]; // { "pending": 0, "approved": 1, ... }
            // Build options array for TomSelect
            var enumOptions = [];
            Object.keys(enumMap).forEach(function(key){
              // humanize key: replace _ with space and capitalize words
              var text = key.replace(/_/g, ' ').replace(/\b\w/g, function(ch){ return ch.toUpperCase(); });
              enumOptions.push({ value: key, text: text });
            });
            // populate and show enum select using TomSelect
            valueEnum.classList.remove('d-none');
            valueEnum.disabled = false;
            var tomInstance = new TomSelect($(valueEnum).get(0), {
              options: enumOptions,
              valueField: 'value',
              labelField: 'text',
              searchField: 'text',
              hideSelected: true,
              maxOptions: 100
            });
            tomInstance.clear();
            tomInstance.addOption(enumOptions);
            tomInstance.refreshOptions(false);
          } else if (dataType === 'date') {
            valueDate.classList.remove('d-none');
            valueDate.disabled = false;
          } else if (dataType === 'datetime') {
            valueDateTime.classList.remove('d-none');
            valueDateTime.disabled = false;
          } else if (dataType === 'boolean') {
            valueSelect.classList.remove('d-none');
            valueSelect.disabled = false;
            var tomInstance = new TomSelect($(valueSelect).get(0), {
              options: [{ value: 'true', text: 'Yes / Approved' }, 
                        { value: 'false', text: 'No / Rejected' }, 
                        { value: 'nil', text: 'Not Specified / Pending' }],
              valueField: 'value',
              labelField: 'text'
            });
            tomInstance.enable();
          } else if (dataType === 'integer' || dataType === 'decimal' || dataType === 'float') {
            if (valueNumber) {
              valueNumber.classList.remove('d-none');
              valueNumber.disabled = false;
              try {
                if (dataType === 'integer') valueNumber.setAttribute('step', '1');
                else valueNumber.setAttribute('step', 'any');
                valueNumber.setAttribute('inputmode', 'numeric');
                // optional: set a pattern for client-side validation
                valueNumber.setAttribute('pattern', dataType === 'integer' ? '\\d+' : '\\d*(\\.\\d+)?');
              } catch(e) {}
            } else {
              valueField.classList.remove('d-none');
              valueField.disabled = false;
            }
          } else {
            // default -> text input
            valueField.classList.remove('d-none');
            valueField.disabled = false;
          }

          // Update operator options (TomSelect-backed)
          if (operatorSelect && operatorSelect.tomselect) {
            var tomSelectInstance = operatorSelect.tomselect;
            tomSelectInstance.clearOptions();
            defaultOperators.forEach(function(option) { tomSelectInstance.addOption(option); });
            tomSelectInstance.refreshOptions(false);
          } else {
            // If operator select not initialized with TomSelect, optionally rebuild native options
            // (left intentionally minimal — your app likely uses TomSelect for operatorSelect)
          }

        },
        error: function(error) {
          var filterError = document.getElementById('filter-error');
          if(filterError) {
            filterError.textContent = 'Error fetching attribute type. Please try again.';
            filterError.classList.remove('d-none');
            setTimeout(function() {
              filterError.classList.add('d-none');
              filterError.textContent = '';
            }, 5000);
          }
          console.error('Error fetching attribute type:', error);
        }
      });
    }
  }

  window.filterDepartments = function(element, eventUrl) {
    var departmentId = $(element).val();
    const locale = document.documentElement.lang;
    const filterData = {
      attribute: ['department_id'],
      operator: ['='],
      value: [departmentId]
    };
    var data = {
      filter: filterData,
      locale: locale
    };
    if(eventUrl === '/welcome/team_requests') {
      data = {
        filter: filterData,
        locale: locale,
        request_status: filterStatusValue,
        request_type: filterTypeValue
      };
    }
    $.ajax({
      url: eventUrl,
      method: 'POST',
      headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: JSON.stringify(data),
      processData: false, // Prevent jQuery from automatically processing the data
      contentType: 'application/json',
      dataType: 'script',
      success: function(data) {
        
      },
      error: function(error) {
          console.error(error);
      }
    });
  }
  
});